/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs */

const es_marketplace_seo_galicia_guide_salvora_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Isla Sálvora, en la Ría de Arousa, es uno de los destinos más demandados del litoral gallego. Solo se accede en barco y forma parte del Parque Nacional das Illas Atlánticas.`)
};

const gl_marketplace_seo_galicia_guide_salvora_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Illa Sálvora, na Ría de Arousa, é un dos destinos máis demandados do litoral galego. Só se accede en barco e forma parte do Parque Nacional das Illas Atlánticas.`)
};

const en_marketplace_seo_galicia_guide_salvora_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sálvora island in Ría de Arousa is one of the most sought-after destinations on the Galician coast. It is only reachable by boat and part of the Atlantic Islands National Park.`)
};

/**
* | output |
* | --- |
* | "Sálvora island in Ría de Arousa is one of the most sought-after destinations on the Galician coast. It is only reachable by boat and part of the Atlantic Isl..." |
*
* @param {Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_salvora_p1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Salvora_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_salvora_p1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_salvora_p1(inputs)
	return es_marketplace_seo_galicia_guide_salvora_p1(inputs)
});